import React from 'react';

const CompletionStage = ({stage}) => {
  
    return (
        <div className="stage-section">
           <h5 className="d-flex align-items-center">   <span className="stage-circle me-2"></span>  {stage.title1}</h5>
            <p className="body-text">{ stage.description1}</p>
        </div>
    );
};

export default CompletionStage;